import { modalVisibilitySelector, toggleModal } from '../../../Store/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../../Store/store';

export const useModalBehavior = (state) => {
  const modalVisibility = useAppSelector(modalVisibilitySelector);
  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(toggleModal());
    if (state?.callback) {
      state.callback();
    }
  };

  return { onClose, modalVisibility };
};
